module.exports = __webpack_public_path__ + "static/img/guardsold.d3ac778.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guardsold.jpg
// module id = a5s5
// module chunks = 0